var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.8905C0.530424 2.84539 1.33819 1.96795 2.33403 1.35512C3.32986 0.742302 4.47499 0.417969 5.64286 0.417969C6.81072 0.417969 7.95585 0.742302 8.95169 1.35512C9.94753 1.96795 10.7553 2.84539 11.2857 3.8905C10.7553 4.9356 9.94753 5.81305 8.95169 6.42587C7.95585 7.03869 6.81072 7.36302 5.64286 7.36302C4.47499 7.36302 3.32986 7.03869 2.33403 6.42587C1.33819 5.81305 0.530424 4.9356 0 3.8905ZM5.64286 6.20397C6.25371 6.20397 6.83954 5.96023 7.27147 5.52637C7.70341 5.09251 7.94606 4.50407 7.94606 3.8905C7.94606 3.27692 7.70341 2.68848 7.27147 2.25462C6.83954 1.82076 6.25371 1.57702 5.64286 1.57702C5.03201 1.57702 4.44618 1.82076 4.01424 2.25462C3.58231 2.68848 3.33965 3.27692 3.33965 3.8905C3.33965 4.50407 3.58231 5.09251 4.01424 5.52637C4.44618 5.96023 5.03201 6.20397 5.64286 6.20397ZM5.64286 5.04723C5.33743 5.04723 5.04452 4.92536 4.82855 4.70843C4.61258 4.4915 4.49125 4.19728 4.49125 3.8905C4.49125 3.58371 4.61258 3.28949 4.82855 3.07256C5.04452 2.85563 5.33743 2.73376 5.64286 2.73376C5.94828 2.73376 6.2412 2.85563 6.45716 3.07256C6.67313 3.28949 6.79446 3.58371 6.79446 3.8905C6.79446 4.19728 6.67313 4.4915 6.45716 4.70843C6.2412 4.92536 5.94828 5.04723 5.64286 5.04723Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/EyeIcon.89786793fb6652d1d3bda38726b472b2.svg";
export { ForwardRef as ReactComponent };